import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'account', en);
i18next.addResources('fr', 'account', fr);

declare global {
  interface RegisteredLocales {
    account: typeof en;
  }
}
